"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var TableActionDelete_1 = require("../../../../../../../../shared/components/table_actions/TableActionDelete");
var WrapTableActions_1 = require("../../../../../../../../shared/components/table_actions/WrapTableActions");
var notificationHelper_1 = require("../../../../../../../../shared/helpers/notificationHelper");
var ToolBarButtonsOnly_1 = require("../../../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var FontAwesome_1 = require("../../../../../../../../shared/components/icons/FontAwesome");
var TableActionEdit_1 = require("../../../../../../../../shared/components/table_actions/TableActionEdit");
var TableMenuIsLocked_1 = require("../../../../../../../../shared/components/table_menus/TableMenuIsLocked");
var UIUtils_1 = require("../../../../../../../../shared/modules/UIUtils");
var TableActionCash_1 = require("../../../../../../../../shared/components/table_actions/TableActionCash");
var BrandPayProvidersList = /** @class */ (function (_super) {
    __extends(BrandPayProvidersList, _super);
    function BrandPayProvidersList(props) {
        return _super.call(this, props) || this;
    }
    BrandPayProvidersList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total
            });
        });
        this.setState({
            data: this.props.data.DATA.data,
            totalRows: 0,
        }, function () {
            _this.props.data.LoadData(_this.props.rootRecord.key);
        });
    };
    BrandPayProvidersList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
    };
    BrandPayProvidersList.prototype.doLockedAction = function (Key, Title, isLocked) {
        var _this = this;
        this.props.data.DoSetIsLocked(Key, isLocked, function () {
            if (isLocked) {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u041F\u043B\u0430\u0442\u0435\u0436\u043D\u044B\u0439 \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440 ",
                    React.createElement("b", null,
                        "[",
                        Title,
                        "]"),
                    " \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D"));
            }
            else {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u041F\u043B\u0430\u0442\u0435\u0436\u043D\u044B\u0439 \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440 ",
                    React.createElement("b", null,
                        "[",
                        Title,
                        "]"),
                    " \u0440\u0430\u0437\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D"));
            }
            _this.props.data.LoadData(_this.props.rootRecord.key);
        });
    };
    BrandPayProvidersList.prototype.getLevelsArray = function () {
        var _ret = [];
        for (var i = 1; i <= 30; i++) {
            _ret.push(React.createElement(antd_1.Menu.Divider, { key: i + 100 }));
            _ret.push(React.createElement(antd_1.Menu.Item, { key: "" + i },
                React.createElement(FontAwesome_1.FA, { icon: "level-down-alt", left: true }),
                "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u2116 ",
                i,
                " "));
        }
        return _ret;
    };
    BrandPayProvidersList.prototype.getMoreActionsDropDownMenu = function (record) {
        var _this = this;
        return (React.createElement(antd_1.Menu, { onClick: function (e) { _this.doMorection(e, record); } }, this.getLevelsArray()));
    };
    BrandPayProvidersList.prototype.doMorection = function (e, record) {
        var _this = this;
        var _level = 1;
        _level = parseInt(e.key, 10);
        this.props.data.DoSetOrderNumber(record.key, _level, function () {
            _this.props.data.LoadData(_this.props.rootRecord.key, function () {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null, "\u041F\u0440\u0438\u043E\u0440\u0438\u0442\u0435\u0442 \u0434\u043B\u044F \u043F\u043B\u0430\u0442\u0435\u0436\u043D\u043E\u0433\u043E \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u0430 \u0438\u0437\u043C\u0435\u043D\u0435\u043D !"));
            });
        });
    };
    BrandPayProvidersList.prototype.getColumns = function () {
        var _this = this;
        return ([{
                title: 'Валюта',
                dataIndex: this.props.data.dk_app_currency_title,
                key: this.props.data.dk_app_currency_title,
                width: 150,
                render: function (text, record, index) {
                    return (React.createElement("div", null,
                        record.app_currency_title,
                        " ",
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "coins" })));
                }
            }, {
                title: 'Ид провайдера',
                dataIndex: this.props.data.dk_provider_identity,
                key: this.props.data.dk_provider_identity,
                width: 150,
            }, {
                title: 'Название провайдера',
                dataIndex: this.props.data.dk_provider_name,
                key: this.props.data.dk_provider_name,
                width: 200,
            }, {
                title: 'Зона провайдера',
                dataIndex: this.props.data.dk_trust_zone_title,
                key: this.props.data.dk_trust_zone_title,
                width: 150,
            }, {
                title: 'Сервис провайдера',
                dataIndex: this.props.data.dk_provider_system,
                key: this.props.data.dk_provider_system,
                width: 200,
            }, {
                title: 'Лого провайдера',
                dataIndex: this.props.data.dk_provider_logo,
                key: this.props.data.dk_provider_logo,
                width: 200,
            }, {
                title: 'Мин деп',
                dataIndex: this.props.data.dk_min_deposit_amount,
                key: this.props.data.dk_min_deposit_amount,
                width: 150,
            }, {
                title: 'Макс деп',
                dataIndex: this.props.data.dk_max_deposit_amount,
                key: this.props.data.dk_max_deposit_amount,
                width: 150,
            }, {
                title: 'Проверять url',
                dataIndex: this.props.data.dk_is_locked,
                key: this.props.data.dk_is_locked,
                align: "center",
                render: function (text, record, idx) {
                    return (React.createElement("div", null, UIUtils_1.UIUtils.bool2Str(record.is_check_url, "ДА", "НЕТ")));
                },
                width: 150,
            }, {
                title: 'Номер п/п',
                dataIndex: this.props.data.dk_order_number,
                key: this.props.data.dk_order_number,
                align: "center",
                render: function (text, record, idx) {
                    return (React.createElement(antd_1.Dropdown, { overlay: _this.getMoreActionsDropDownMenu(record), trigger: ['click'] },
                        React.createElement(antd_1.Button, { style: { width: 120, minWidth: 120, maxWidth: 120 } },
                            "\u041D\u043E\u043C\u0435\u0440 ",
                            record.order_number,
                            " ",
                            React.createElement(antd_1.Icon, { type: "down" }))));
                },
                width: 130,
            }, {
                title: 'Заблокирован',
                dataIndex: this.props.data.dk_is_locked,
                key: this.props.data.dk_is_locked,
                align: "center",
                render: function (text, record, idx) {
                    return (React.createElement(TableMenuIsLocked_1.default, { unlockedTexts: { menu: "Разблокировать", text: "Нет" }, lockedTexts: { menu: "Заблокировать", text: "Да" }, record: { key: record.key, title: record.provider_name, locked: record.is_locked }, onLockClick: _this.doLockedAction.bind(_this) }));
                },
                width: 150,
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionEdit_1.default, { hint: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C", onClick: function () { _this.onEditDataClick(record); } }),
                    React.createElement(TableActionCash_1.default, { hint: "\u0423\u0437\u043D\u0430\u0442\u044C \u043B\u0438\u043C\u0438\u0442\u044B", onClick: function () { _this.onViewLimitDataClick(record); } }),
                    React.createElement(TableActionDelete_1.default, { hint: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", confirmText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onDeletePlayerClick(record); } }))); },
                width: 80
            }]);
    };
    BrandPayProvidersList.prototype.onViewLimitDataClick = function (record) {
        var _this = this;
        this.props.data.getPayProviderLimitsDetails(record.key, function (limits) {
            _this.props.dialogViewText
                .SetText(" \u0421\u043E\u0432\u0435\u0440\u0448\u0435\u043D\u043E: " + limits.dep_amount_done_last_24h + " \n \u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E: " + limits.dep_amount_max_last_24h + " \n \u0415\u0441\u0442\u044C \u043B\u0438\u043C\u0438\u0442: " + UIUtils_1.UIUtils.bool2Str(limits.is_dep_amount_max_last_24h, 'Да', 'Нет') + " ")
                .SetTitle("Лимиты по провайдеру")
                .SetOnCloseClick(function () {
                _this.props.dialogViewText.Close();
            }).Show();
        });
        //if (this.props.onEditClick) {
        //    this.props.onEditClick(record);
        //}
    };
    BrandPayProvidersList.prototype.onEditDataClick = function (record) {
        if (this.props.onEditClick) {
            this.props.onEditClick(record);
        }
    };
    BrandPayProvidersList.prototype.onDeletePlayerClick = function (record) {
        this.props.data.DeleteData(record.key, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                "\u041F\u043B\u0430\u0442\u0435\u0436\u043D\u044B\u0439 \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440 ",
                React.createElement("b", null,
                    "[",
                    record.provider_name,
                    "]"),
                " \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D"));
        });
    };
    BrandPayProvidersList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.props.data.LoadData(this.props.rootRecord.key);
        }
        if (action === "create") {
            if (this.props.onCreateClick) {
                this.props.onCreateClick();
            }
        }
        if (action === "back") {
            if (this.props.onGoBackClick) {
                this.props.onGoBackClick();
            }
        }
    };
    BrandPayProvidersList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { create: "Создать", refresh: "Обновить", back: "Назад" }, onClick: this.onToolBarClick.bind(this) }),
            React.createElement(antd_1.Table, { bordered: true, columns: this.getColumns(), dataSource: this.state.data, locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, pagination: {
                    pageSize: this.props.state.UITablePageSize,
                    showSizeChanger: true,
                    total: this.state.totalRows,
                    position: "bottom",
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) { return React.createElement("div", { style: { margin: 0 } },
                    React.createElement("div", null,
                        React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                        " [",
                        record.key,
                        "] "),
                    React.createElement("div", null,
                        React.createElement("b", null, "\u041F\u0440\u043E\u0432\u0435\u0440\u044F\u0442\u044C url:"),
                        " [",
                        UIUtils_1.UIUtils.bool2Str(record.is_check_url, "ДА", "НЕТ"),
                        "] "),
                    React.createElement("div", null,
                        React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D:"),
                        " [",
                        record.date_added2.format(_this.props.state.getDateTimeFormat()),
                        "] "),
                    React.createElement("div", null,
                        React.createElement("b", null, "\u0418\u0437\u043C\u0435\u043D\u0435\u043D:"),
                        " [",
                        record.date_changed2.format(_this.props.state.getDateTimeFormat()),
                        "]"),
                    React.createElement("div", null,
                        React.createElement("b", null, "\u0414\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0439:"),
                        " [",
                        UIUtils_1.UIUtils.bool2Str(record.is_trusted_only, "ДА", "НЕТ"),
                        "] "),
                    React.createElement("div", null,
                        React.createElement("b", null, "\u041C\u043E\u0431\u0438\u043B\u044C\u043D\u044B\u0439:"),
                        " [",
                        UIUtils_1.UIUtils.bool2Str(record.is_mobile, "ДА", "НЕТ"),
                        "] "),
                    React.createElement("div", null,
                        React.createElement("b", null, "\u0414\u0435\u0441\u043A\u0442\u043E\u043F\u043D\u044B\u0439:"),
                        " [",
                        UIUtils_1.UIUtils.bool2Str(record.is_desktop, "ДА", "НЕТ"),
                        "] "),
                    React.createElement("div", null,
                        React.createElement("b", null, "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435:"),
                        " [",
                        record.description,
                        "] "),
                    React.createElement("div", null,
                        React.createElement("b", null, "\u0415\u0441\u0442\u044C \u0440\u0430\u043D\u0434\u043E\u043C\u043D\u044B\u0439 \u043B\u0438\u043C\u0438\u0442:"),
                        " [",
                        UIUtils_1.UIUtils.bool2Str(record.is_randomize_per_day_amount_by_percent, "ДА", "НЕТ"),
                        "] "),
                    React.createElement("div", null,
                        React.createElement("b", null, "\u0417\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0440\u0430\u043D\u0434\u043E\u043C\u043D\u043E\u0433\u043E \u043B\u0438\u043C\u0438\u0442\u0430:"),
                        " [",
                        record.randomized_min_dep_amount_per_day_limit,
                        "] ")); }, scroll: { x: true } })));
    };
    return BrandPayProvidersList;
}(React.Component));
exports.default = BrandPayProvidersList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_brands_list/ui/component/options/pay_providers/BrandPayProvidersList.tsx
// module id = 1798
// module chunks = 0